/**
 * Sentinel for a `/stock/$ticker` path param that fails `RequestedTickerSchema`.
 *
 * TanStack Router's CatchBoundary routes BOTH `params.parse` failures and
 * render-time exceptions from the route subtree to the same `errorComponent`,
 * so the boundary needs a discriminant. Without one, a crash inside PriceChart
 * is reported to the user as a bad ticker — a wrong answer that reads as a
 * correct one (plan §1.4 · error §6).
 */

import { errorHasKind } from '@/lib/errors/error-has-kind';

/** Discriminant, so a catch site does not depend on `instanceof` surviving a bundler. */
const INVALID_TICKER_PARAM = 'invalid-ticker-param';

export class InvalidTickerParamError extends Error {
  public readonly kind = INVALID_TICKER_PARAM;

  public constructor() {
    super('INVALID_STOCK_TICKER');
    this.name = 'InvalidTickerParamError';
  }
}

/**
 * Not a type predicate: a true result may describe the CAUSE of the wrapper
 * that was passed in, not the wrapper itself.
 */
export function isInvalidTickerParamError(error: unknown): boolean {
  return errorHasKind(error, INVALID_TICKER_PARAM);
}
